import { io } from "../prelude";
export const DEFAULT_LAYOUT: Layout = "article";

export const Layout = io.keyof({
  home: null,
  simple: null,
  article: null,
  articleNarrow: null,
  full: null,
  explorer: null,
  focus: null,
  none: null,
});
export type Layout = io.TypeOf<typeof Layout>;

export function foldLayout<A>(x: Layout, pattern: Record<Layout, (x: Layout) => A>): A {
  return pattern[x](x);
}
